"use strict";
var $ = require("../internals/export");
var anObject = require("../internals/an-object");
var objectGetPrototypeOf = require("../internals/object-get-prototype-of");
var CORRECT_PROTOTYPE_GETTER = require("../internals/correct-prototype-getter");
$({ target: "Reflect", stat: true, sham: !CORRECT_PROTOTYPE_GETTER }, {
  getPrototypeOf: function getPrototypeOf(target) {
    return objectGetPrototypeOf(anObject(target));
  }
});
